import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
import { ZERO_WIDTH_SPACE_CSS } from "../../../lib/chars";
import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  icon: function icon() {
    var space = "'" + ZERO_WIDTH_SPACE_CSS + "'";
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      display: inline-block;\n\n      &::before {\n        content: ", ";\n      }\n    "])), space);
  },
  iconSmall: function iconSmall(t) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      width: ", ";\n    "])), t.btnIconSizeSmall);
  },
  iconSmallLeft: function iconSmallLeft(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n    "])), t.btnIconGapSmallLeft);
  },
  iconSmallRight: function iconSmallRight(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      margin-left: ", ";\n    "])), t.btnIconGapSmallRight);
  },
  iconMedium: function iconMedium(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      width: ", ";\n    "])), t.btnIconSizeMedium);
  },
  iconMediumLeft: function iconMediumLeft(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n    "])), t.btnIconGapMediumRight);
  },
  iconMediumRight: function iconMediumRight(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      margin-left: ", ";\n    "])), t.btnIconGapMediumRight);
  },
  iconLarge: function iconLarge(t) {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n      width: ", ";\n    "])), t.btnIconSizeLarge);
  },
  iconLargeLeft: function iconLargeLeft(t) {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n    "])), t.btnIconGapLargeLeft);
  },
  iconLargeRight: function iconLargeRight(t) {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      margin-left: ", ";\n    "])), t.btnIconGapLargeRight);
  },
  iconLeftLink: function iconLeftLink(t) {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      margin-right: ", ";\n    "])), t.btnLinkIconMarginRight);
  },
  iconRightLink: function iconRightLink(t) {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n      margin-left: ", ";\n    "])), t.btnLinkIconMarginLeft);
  },
  iconNoMargin: function iconNoMargin() {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n      margin-right: 0;\n      margin-left: 0;\n    "])));
  }
});